/** @format */

/**
 * THIS IS VERY IMPORTANT - DO NOT ADD ANYTHING OR DELETE THIS FILE.
 * IF YOU MUST ADD SOMETHING TO THIS PLEASE ADD IT IN - scripts/templates
 */

export const api = {
    apiUrl: "https://api.konfhub.com",
    graphQlUrl: "https://sponsor-api.konfhub.com/graphql",
    certhubAPIUrl: "https://certhub-api.konfhub.com",
    checkinAppUrl: "https://checkin-api.konfhub.com/graphql",
    getQuizzesApiUrl: "https://qh-api.konfhub.com",
    quizhubApiUrl: "https://quizhub-production-apim.azure-api.net",
    filesApiUrl: "https://files.konfhub.com",
    pollerApiUrl: "https://regional-api.konfhub.com"
};

/**
 * THIS IS VERY IMPORTANT - DO NOT ADD ANYTHING OR DELETE THIS FILE.
 * IF YOU MUST ADD SOMETHING TO THIS PLEASE ADD IT IN - scripts/templates
 */
